export const INFO_SHOW_RESET = 'INFO_SHOW_RESET';
export const INFO_SHOW_SET_ERROR = 'INFO_SHOW_SET_ERROR';
export const INFO_SHOW_SET_RETRIEVED = 'INFO_SHOW_SET_RETRIEVED';
export const INFO_SHOW_TOGGLE_LOADING = 'INFO_SHOW_TOGGLE_LOADING';



// WEBPACK FOOTER //
// ./src/store/modules/info/show/mutation_types.js